module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.baseInfo.type !== 0 && !_vm.loading) ? _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "userName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.data, "userName", $$v)
      },
      expression: "data.userName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "documentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.documentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "documentsType", $$v)
      },
      expression: "data.documentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "idCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "idCardNo", $$v)
      },
      expression: "data.idCardNo"
    }
  }), _vm._v(" "), _c('datetime', {
    ref: "documentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件有效期",
      "placeholder": "证件号码有效期",
      "disabled": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": "",
      "start-date": "2019-07-18",
      "end-date": "2099-12-31"
    },
    model: {
      value: (_vm.data.documentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "documentsValidity", $$v)
      },
      expression: "data.documentsValidity"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "forever weui-cell"
  }, [_c('check-icon', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "value": _vm.isYJ,
      "type": "plain"
    },
    on: {
      "update:value": function($event) {
        _vm.isYJ = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999999"
    }
  }, [_vm._v("若为永久有效，请勾选")])])], 1)], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "userCountry",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "国籍",
      "placeholder": "请输入国籍",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.userCountry),
      callback: function($$v) {
        _vm.$set(_vm.data, "userCountry", $$v)
      },
      expression: "data.userCountry"
    }
  }), _vm._v(" "), _c('selector', {
    ref: "userSex",
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "userSex", $$v)
      },
      expression: "data.userSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.userAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "userAge", $$v)
      },
      expression: "data.userAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('my-selector', {
    ref: "userOccupation",
    attrs: {
      "title": "职业",
      "placeholder": "请选择职业",
      "disabled": _vm.baseInfo.type === 0,
      "options": ['党政机关、事业单位', '企业单位', '自由业主', '学生', '军人', '其他']
    },
    model: {
      value: (_vm.data.userOccupation),
      callback: function($$v) {
        _vm.$set(_vm.data, "userOccupation", $$v)
      },
      expression: "data.userOccupation"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userPosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "userPosition", $$v)
      },
      expression: "data.userPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userLandline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "请输入座机",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userLandline),
      callback: function($$v) {
        _vm.$set(_vm.data, "userLandline", $$v)
      },
      expression: "data.userLandline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "placeholder": "请输入手机",
      "required": ""
    },
    model: {
      value: (_vm.data.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "userMobile", $$v)
      },
      expression: "data.userMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "userEmail", $$v)
      },
      expression: "data.userEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "zip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "邮编",
      "max": 6,
      "type": "tel",
      "keyboard": "number",
      "placeholder": "请输入邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.zip),
      callback: function($$v) {
        _vm.$set(_vm.data, "zip", $$v)
      },
      expression: "data.zip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "住址",
      "placeholder": "请输入住址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "userAddress", $$v)
      },
      expression: "data.userAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_personal_auth
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.type === 0 && !_vm.loading) ? _c('one-look', {
    attrs: {
      "propData": _vm.data,
      "baseInfo": _vm.baseInfo,
      "hasResp": _vm.hasResp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e27e9a4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Personal/One.vue
// module id = 1073
// module chunks = 1